import React from "react";

import { FTFlex } from "../flex";
import { Button } from "../button";
import { useTranslation } from "react-i18next";
import { useCommonStore, useUserStore } from "@/stores";
import { DownloadSvg, IconHistoryLine } from "@/assets/icons";
import saveAs from "file-saver";
import { getFileName, showDownloadSuccessResult } from "@/utils";
import styles from "./index.module.scss";
import Tooltip from "../tooltip";
import FTAnalytic from "@/analyze/FTAnalytic";
import { PROJECT_TYPE } from "@/constants";
import Analyse from "@/utils/analyse";
import { FeatureType, PageType } from "@/stores/useCommonStore";

export default function PcHeaderComponent() {
  const { t } = useTranslation();
  const task = useCommonStore((state) => state.getters.task);
  const isLogin = useUserStore((state) => state.getters.isLogin);
  const showLogin = useUserStore((state) => state.showLogin);
  const pageType = useCommonStore((state) => state.pageType);
  const featureType = useCommonStore((state) => state.featureType);
  const handleDownload = () => {
    const { resultUrl, thumUrl } = useCommonStore.getState().getters;
    try {
      Analyse.getInstance().download("nav_download");
      saveAs(resultUrl, getFileName(resultUrl));
      Analyse.getInstance().downloadResult("nav_download", true);
    } catch (e) {}

    showDownloadSuccessResult(thumUrl);
  };

  const handleRescent = () => {
    Analyse.getInstance().featureClick('recent_creation')

    const type = featureType === FeatureType.Video ? "aiFaceSwapVideo" : "face-swap";
    const url = `${process.env.REACT_APP_BASE_URL}/cloud/all-creations/?type=${type}`;
    if (isLogin) {
      window.open(url);
    } else {
      showLogin({
        options: {
          position: "my creation",
        },
        callback: () => {
          window.open(url);
        },
      });
    }
  };
  return (
    <FTFlex justify="space-between" style={{ marginRight: 16 }} direction="row">
      <div className="left"></div>
      <FTFlex className={styles.right} gap={16}>
        {isLogin && <div className={styles.recent} onClick={handleRescent}>
          <IconHistoryLine />
          <Tooltip content={t("recent-tip")} placement="bottom"></Tooltip>
        </div>}
        <Button
          primary={true}
          disabled={!task || pageType !== PageType.Result}
          style={{ borderRadius: 20 }}
          onClick={handleDownload}
        >
          <DownloadSvg />
          {t("download-button")}
        </Button>
      </FTFlex>
    </FTFlex>
  );
}
